import { serializable, alias, object, list, primitive } from 'serializr';

export class BrandsList {
  @serializable(alias('id', primitive()))
  id?: number;

  @serializable(alias('name', primitive()))
  name?: string;

  @serializable(alias('category', primitive()))
  category?: string;

  @serializable(alias('company_id', primitive()))
  companyId?: number;

  @serializable(alias('createdAt', primitive()))
  createdAt?: string;

  @serializable(alias('updatedAt', primitive()))
  updatedAt?: string;

  @serializable(alias('emission', primitive()))
  emission?: number;

  @serializable(alias('product', primitive()))
  product?: number;
}
